<!-- Image Settings -->
<form [formGroup]="imageWidgetForm">
  <div>
    <div class="form-group">
      <div class="row mb-2">
        <div class="col">
          <label translate>Cloud Storage path</label>
          <em [ngbTooltip]="'By default {projectId}.appspot.com/images is used.'|translate"
              class="fa-solid fa-circle-question text-muted ml-1"
              placement="top"></em>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input formControlName="customStoragePath" id="customStoragePath" type="text" class="form-control"
                 [placeholder]="'Enter path ...'|translate" (input)="onCustomStoragePathChange()"
                 [ngClass]="{ 'is-invalid': formControls.customStoragePath.errors }">
          <div class="input-group-append">
            <button (click)="onResetCustomStoragePath()" class="btn btn-outline-primary btn-sm"
                    [ngbTooltip]="'Reset to default'|translate">
              <span class="fa-solid fa-rotate-right mr-1"></span>
            </button>
          </div>
        </div>
        @if (formControls.customStoragePath.errors) {
          <div class="invalid-feedback">
            @if (formControls.customStoragePath.errors.required) {
              <span translate>Cloud storage path is required</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group">
      <div class="row mb-2">
        <div class="col">
          <label>
            <span translate>Image preview</span>
          </label>
          <em [ngbTooltip]="'Please consider the ratio and potential white space around the picture when displayed on the dashboard. Ideally pictures have a transparent background.'|translate"
              class="fa-solid fa-circle-question text-muted ml-1"
              placement="top"></em>
          @if (isLoadingImagePreview) {
            <span class="fa-solid fa-gear fa-spin"></span>
          }
          <div class="image-widget-preview">
            <button (click)="deleteImage()" class="btn btn-xs btn-outline-danger" placement="top"
                    [ngbTooltip]="'Delete image'|translate">
              <span class="fa-solid fa-trash"></span>
            </button>
            <div class="form-group">
              @if (!isLoadingImagePreview && !isLoadingImageFromMetaField && !formControls.image.value) {
                <div
                    class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
                    <span>
                      <span class="mr-1" translate>Image not defined or could not be loaded.</span>
                      <span [innerHTML]="imageName"></span>
                    </span>
                </div>
              }

              @if (!isLoadingImagePreview && formControls.image.value) {
                <img [src]="formControls.image.value"
                     class="image-fill-parent" alt=""
                     [ngClass]="{ 'is-invalid': formControls.image.errors }">
              }
              @if (formControls.image.errors) {
                <div class="invalid-feedback">
                  @if (formControls.image.errors.required) {
                    <span translate>Image is required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col">
          <span class="form-label" translate>Method</span>
          <div class="btn-group d-flex btn-group-toggle" ngbRadioGroup
               name="radioBasic">
            <label ngbButtonLabel class="btn btn-outline-primary"
                   [class.active]="isImage">
              <input ngbButton type="radio"
                     (click)="selectImageType(ImageSourceType.IMAGE_UPLOAD)">
              <span translate>Image Upload</span>
            </label>
            <label ngbButtonLabel class="btn btn-outline-primary"
                   [class.active]="isMapping">
              <input ngbButton type="radio"
                     (click)="selectImageType(ImageSourceType.METAFIELD)">
              <span translate>Cloud Storage mapping</span>
            </label>
          </div>
          @if (isImage) {
            <div>
              <div class="form-group text-center mt-5">
                <scitis-file-upload
                    (fileLoadError)="onFileUploadError($event)"
                    (fileLoadEvent)="onFileUploadComplete($event)"
                    (fileNameLoadEvent)="onFileNameUploadComplete($event)"
                    [maxFileSize]="maxFileSize"
                    label="Browse"
                    [fileTypes]="imageFileTypes"
                    [isDisabled]="isFileUploadDisabled">
                </scitis-file-upload>
                <button (click)="onUploadToCloudStorage()" class="btn btn-outline-primary ml-2"
                        [disabled]="isCSUploadDisabled">
                  <span class="fa-solid fa-upload"></span>
                  <span [innerText]="'Upload to Cloud Storage' | translate"></span>
                </button>
              </div>
            </div>
          }
          @if (isMapping) {
            <div>
              <div class="form-group mt-3">
                <label>
                  <span translate>Meta field</span>
                </label>
                @if (isLoadingImageFromMetaField) {
                  <span class="fa-solid fa-gear fa-spin"></span>
                }
                <ng-select
                    [items]="metaDataFields"
                    (change)="onMetaFieldSelected($event)"
                    formControlName="selectedMetaDataField"
                    bindLabel="key"
                    [placeholder]="'Select meta field ...' | translate"
                    [ngClass]="{ 'is-invalid': formControls.selectedMetaDataField.errors }">
                </ng-select>
                <small class="form-text text-muted" translate>Selected meta field should contain the image file (not full path)
                  name,
                  e.g.
                  xyz.png or xyz.jpg (Only jpg and png are supported).</small>
                @if (formControls.selectedMetaDataField.errors) {
                  <div class="invalid-feedback">
                    @if (formControls.selectedMetaDataField.errors.required) {
                      <span translate>Meta field is required</span>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
